import './index.css';
import { Dots } from 'react-activity';
import View from '../../view';
import Text from '../../text';
import useTheme from '../../../utilities/hooks/theme';
import { CSSProperties } from 'react';
import React from 'react';
interface Props {
  loadingMessage: string;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}
const Loader = ({ style, className, loadingMessage }: Props) => {
  const { DefaultTheme: theme } = useTheme();
  const placeholderLoaderMessage = {
    color: theme.placeholderLoaderMessage
  };
  return (
    <View style={style} className={`${className} placeholder-loader-container`}>
      <Dots size={25} color={theme.placeholderLoaderMessage} />
      <Text className={'placeholder-loader-message'} style={placeholderLoaderMessage}>
        {loadingMessage}
      </Text>
    </View>
  );
};
Loader.defaultProps = {
  loadingMessage: 'Fetching Data, Please wait....',
  className: '',
  style: {}
};
export default React.memo(Loader);
